const translations = {
    productUsageReport: 'Product Usage Report'
};

export default translations;
